import { __awaiter, __decorate, __metadata, __param } from 'tslib';
import { SpeNOpenAccountProxy, ConfigService, SpeViewPreAccountProxy, UiPxDeviceValidationModule } from '@wlp/ui-px-device-validation';
import { Injectable, NgModule, Optional, SkipSelf } from '@angular/core';
import { FormControl, Validators, FormBuilder, FormsModule } from '@angular/forms';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { BaseService, PasswordValidator, MatchValidator, ErrorMessageService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { BehaviorSubject } from 'rxjs';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';

class PreAccountResponse {
}

let CreatePasswordService = class CreatePasswordService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorFormMessages = {
            password: [
                {
                    type: 'minSpecialChar',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.MIN_SPECIAL_CHAR',
                    param: {
                        minSpecialChar: 1
                    }
                },
                {
                    type: 'minNumberChar',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.MIN_NUMBER_CHAR',
                    param: {
                        minNumberChar: 1
                    }
                },
                {
                    type: 'minUpperChar',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.MIN_UPPER_CHAR',
                    param: {
                        minUpperChar: 1
                    }
                },
                {
                    type: 'minLowerChar',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.MIN_LOWER_CHAR',
                    param: {
                        minLowerChar: 1
                    }
                },
                {
                    type: 'hasEmptySpace',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.HAS_EMPTY_SPACE',
                }
            ],
            confirmPassword: [
                {
                    type: 'mustMatch',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.CONFIRM_PASSWORD.MESSAGE.MUST_MATCH'
                }
            ]
        };
        this.loadKeyAccount();
    }
    getForm() {
        this.formPassword = this.formBuilder.group({
            password: new FormControl('', Validators.compose([
                Validators.required,
                PasswordValidator.minChar,
                PasswordValidator.minUpperChar,
                PasswordValidator.minLowerChar,
                PasswordValidator.minNumberChar,
                PasswordValidator.minSpecialChar,
                PasswordValidator.hasEmptySpace
            ])),
            confirmPassword: new FormControl('', Validators.compose([
                Validators.required
            ])),
        }, {
            validator: MatchValidator.mustMatch('password', 'confirmPassword')
        });
        return this.formPassword;
    }
    getErrorFormMessage() {
        return this.errorFormMessages;
    }
    getTypeFLow() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKeyAccount();
            return this.keyPreAccount;
        });
    }
    createPassword(nextStep, idBusinessPartner) {
        const preAccount = this.preparePasswordData(idBusinessPartner);
        preAccount.lastStep = nextStep;
        this.loadKeyAccount();
        return this.speNOpenAccountProxy.createPassword(this.keyPreAccount, preAccount);
    }
    getErrorPassword(error) {
        this.errorMessageService.getError(error);
    }
    preparePasswordData(idBusinessPartner) {
        const data = this.formPassword.getRawValue();
        const preAccountResponse = new PreAccountResponse();
        const passwordDataResponse = {
            password: data.password,
            idBusinessPartner: idBusinessPartner
        };
        preAccountResponse._id = this.keyPreAccount;
        preAccountResponse.passwordData = passwordDataResponse;
        return preAccountResponse;
    }
    loadKeyAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
        });
    }
};
CreatePasswordService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        SpeNOpenAccountProxy,
        Storage,
        ConfigService,
        ErrorMessageService])
], CreatePasswordService);

class SendValidationPhoneResponse {
}

let DeviceService = class DeviceService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorFormMessages = {
            phone: [
                { type: 'required', message: 'ONBORDING.VALIDATION_PHONE.FORM.PHONE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.VALIDATION_PHONE.FORM.PHONE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 10 },
                },
            ],
        };
    }
    getForm() {
        this.formDevice = this.formBuilder.group({
            phone: new FormControl('', Validators.compose([Validators.required, Validators.minLength(13)])),
        });
        return this.formDevice;
    }
    updateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            if (!!this.keyPreAccount) {
                this.getPreAccount(this.keyPreAccount);
            }
        });
    }
    getPreAccount(uuid) {
        this.keyPreAccount = uuid;
        this.speNOpenAccountProxy.getPreAccount(uuid).subscribe(({ deviceValidation }) => {
            if (deviceValidation) {
                this.syncForm(deviceValidation.phone);
            }
        }, (err) => {
            this.errorMessageService.getError(err);
        });
    }
    syncForm(phone) {
        this.formDevice.patchValue({
            phone,
        });
    }
    getErrorFormMessagen() {
        return this.errorFormMessages;
    }
    getErrorDevice(error) {
        this.errorMessageService.getError(error);
    }
    createDevice() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            const data = this.formDevice.getRawValue();
            const sendValidationPhoneResponse = new SendValidationPhoneResponse();
            sendValidationPhoneResponse.id = this.keyPreAccount;
            sendValidationPhoneResponse.phone = data.phone;
            return this.speNOpenAccountProxy.sendValidationPhone(sendValidationPhoneResponse).toPromise();
        });
    }
    createDeviceMigration(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const sendValidationPhoneResponse = new SendValidationPhoneResponse();
            sendValidationPhoneResponse.id = data.id;
            sendValidationPhoneResponse.phone = data.phone;
            return this.speNOpenAccountProxy.sendValidationPhone(sendValidationPhoneResponse).toPromise();
        });
    }
};
DeviceService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        SpeNOpenAccountProxy,
        Storage,
        ConfigService,
        ErrorMessageService])
], DeviceService);

class CodeDeviceValidationResponse {
}

class ResendCodeResponse {
}

let SendCodeService = class SendCodeService extends BaseService {
    constructor(formBuilder, speNOpenAccountProxy, speViewPreAccountProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewPreAccountProxy = speViewPreAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorFormMessages = {
            codeNumberOne: [
                { type: 'required', message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 1 },
                },
            ],
            codeNumberTwo: [
                { type: 'required', message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 1 },
                },
            ],
            codeNumberThree: [
                { type: 'required', message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 1 },
                },
            ],
            codeNumberFour: [
                { type: 'required', message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 1 },
                },
            ],
            codeNumberFive: [
                { type: 'required', message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.VALIDATION_PHONE_CODE.FORM.CODE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 1 },
                },
            ],
        };
        this.celPhone = new BehaviorSubject('');
        this.loadData();
    }
    getErrorFormMessage() {
        return this.errorFormMessages;
    }
    getForm() {
        this.formSendCode = this.formBuilder.group({
            codeNumberOne: new FormControl('', Validators.compose([Validators.required])),
            codeNumberTwo: new FormControl('', Validators.compose([Validators.required])),
            codeNumberThree: new FormControl('', Validators.compose([Validators.required])),
            codeNumberFour: new FormControl('', Validators.compose([Validators.required])),
            codeNumberFive: new FormControl('', Validators.compose([Validators.required])),
        });
        return this.formSendCode;
    }
    loadData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.celPhone = new BehaviorSubject('');
            yield this.loadKey();
            this.speViewPreAccountProxy
                .findDevice(this.keyPreAccount)
                .toPromise()
                .then((data) => {
                // console.log('findDevice', data);
                if (!!data.phone) {
                    this.celPhone.next(data.phone);
                }
            })
                .catch((err) => this.getErrorSendCode(err));
        });
    }
    setCelPhone(celPhoneForm) {
        this.celPhone.next(celPhoneForm);
    }
    getCelPhone() {
        return this.celPhone;
    }
    getErrorSendCode(error) {
        this.errorMessageService.getError(error);
    }
    sendCode() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            const codeDeviceValidation = new CodeDeviceValidationResponse();
            const data = this.formSendCode.getRawValue();
            codeDeviceValidation.id = this.keyPreAccount;
            codeDeviceValidation.code = `${data.codeNumberOne}${data.codeNumberTwo}${data.codeNumberThree}${data.codeNumberFour}${data.codeNumberFive}`;
            return this.speNOpenAccountProxy.sendCodeDevice(codeDeviceValidation).toPromise();
        });
    }
    resend() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadKey();
            const resendCodeResponse = new ResendCodeResponse();
            resendCodeResponse.id = this.keyPreAccount;
            this.speNOpenAccountProxy.resendCode(resendCodeResponse).subscribe((res) => null, // tratamento de mensagem,
            (error) => this.errorMessageService.getError(error));
        });
    }
    loadAccountMigration(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.speViewPreAccountProxy
                .findAccountMigration(uuid);
        });
    }
    sendCodeMigration(formSendCode, uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const codeDeviceValidation = new CodeDeviceValidationResponse();
            const data = formSendCode.getRawValue();
            codeDeviceValidation.id = uuid;
            codeDeviceValidation.code = `${data.codeNumberOne}${data.codeNumberTwo}${data.codeNumberThree}${data.codeNumberFour}${data.codeNumberFive}`;
            return this.speNOpenAccountProxy.sendCodeDevice(codeDeviceValidation).toPromise();
        });
    }
};
SendCodeService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        SpeNOpenAccountProxy,
        SpeViewPreAccountProxy,
        Storage,
        ConfigService,
        ErrorMessageService])
], SendCodeService);

var UiBsDeviceValidationModule_1;
let UiBsDeviceValidationModule = UiBsDeviceValidationModule_1 = class UiBsDeviceValidationModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsDeviceValidationModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsDeviceValidationModule = UiBsDeviceValidationModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql']
            }),
            UiPxDeviceValidationModule,
            UiBsUtilModule,
            UiBsTranslateModule,
        ],
        providers: [CreatePasswordService, DeviceService, SendCodeService],
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiBsDeviceValidationModule])
], UiBsDeviceValidationModule);

export { CreatePasswordService, DeviceService, SendCodeService, UiBsDeviceValidationModule };
//# sourceMappingURL=wlp-ui-bs-device-validation.js.map
